import { useState } from 'react';
import Navbar from '../components/Navbar';
import contactImage from '../images/84d613a1-4c88-4dc6-8229-bc8e5a314825.png';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-primary-50 via-blue-50 to-indigo-50 py-14 sm:py-20">
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%232563eb' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        ></div>
        <div className="relative mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <h1 className="font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-foreground tracking-tight mb-6">
            We're here to help
          </h1>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto mb-6 text-justify">
            Have questions about our services? Our dedicated team is ready to support you on your journey to parenthood.
          </p>
          <div className="inline-flex items-center rounded-full px-4 py-1.5 text-sm font-semibold bg-primary-100 text-primary-700 shadow-sm">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Get in Touch
          </div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-12 sm:py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Contact Info */}
            <div>
              <h2 className="font-bold text-3xl sm:text-4xl text-foreground mb-6">
                Let's start a conversation
              </h2>
              <p className="text-lg text-muted-foreground mb-10 text-justify">
                Whether you're just starting your research or ready to begin the process, we're here to answer your questions and provide guidance.
              </p>

              {/* Image */}
              <div className="mb-6 sm:mb-10 rounded-3xl overflow-hidden shadow-xl aspect-square">
                <img 
                  src={contactImage} 
                  alt="Contact" 
                  className="w-full h-full object-cover"
                />
              </div>

            </div>

            {/* Contact Form */}
            <div className="space-y-6">
              {/* Email Box */}
              <div className="rounded-3xl border border-border bg-white p-8 sm:p-10 shadow-large">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center">
                    <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">Email Us</h3>
                    <a 
                      href="mailto:TheOpenSpermbank@proton.me"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      TheOpenSpermbank@proton.me
                    </a>
                  </div>
                </div>
              </div>

              {/* Contact Form Box */}
              <div className="rounded-3xl border border-border bg-white p-8 sm:p-10 shadow-large">
                <h3 className="font-bold text-2xl text-foreground mb-6">Or send us a message</h3>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full rounded-xl border border-border bg-white px-4 py-3 text-foreground outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-all"
                    placeholder="John Doe"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full rounded-xl border border-border bg-white px-4 py-3 text-foreground outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-all"
                    placeholder="john@example.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full rounded-xl border border-border bg-white px-4 py-3 text-foreground outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-all"
                    placeholder="How can we help you?"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    className="w-full rounded-xl border border-border bg-white px-4 py-3 text-foreground outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-all resize-none"
                    placeholder="Tell us more about your needs..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-500 rounded-full hover:shadow-xl hover:scale-105 transition-all duration-200 shadow-lg"
                >
                  Send Message
                  <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
              </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 sm:py-20 lg:py-28 bg-secondary">
        <div className="mx-auto max-w-4xl px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <div className="inline-flex items-center rounded-full px-4 py-1.5 text-sm font-semibold bg-primary-100 text-primary-700 mb-4">
              Common Questions
            </div>
            <h2 className="font-bold text-4xl sm:text-5xl text-foreground tracking-tight">
              Frequently Asked Questions
            </h2>
          </div>

          <div className="space-y-4">
            {[
              {
                q: "How long does the donor selection process take?",
                a: "The timeline varies by individual, but most families spend 2-4 weeks reviewing profiles and making their selection. Once you've chosen a donor, we can typically coordinate shipping within 1-2 weeks."
              },
              {
                q: "Are all donors medically screened?",
                a: "Yes, 100% of our donors undergo comprehensive medical screening including genetic testing, infectious disease screening, and physical examinations by licensed physicians at our FDA-registered facility."
              },
              {
                q: "What is the subsidy program?",
                a: "Many of our donors offer subsidized pricing to make family building more accessible. Eligible families can receive vials at $1,000-$1,200 instead of full retail pricing. Apply directly through donor profiles."
              },
              {
                q: "Can I meet or video chat with a donor?",
                a: "Yes! We offer optional video interviews with donors who opt into this program. This unique feature allows you to get to know your donor personally before making your decision."
              }
            ].map((faq, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 shadow-soft hover:shadow-medium transition-all duration-300">
                <h3 className="font-semibold text-lg text-foreground mb-2">{faq.q}</h3>
                <p className="text-muted-foreground leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 py-12">
          <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-slate-400 text-sm">
            <div>© {new Date().getFullYear()} The Open Sperm Bank, LLC. All rights reserved.</div>
            <div className="flex items-center gap-4">
              <span className="flex items-center gap-2">
                <svg className="w-4 h-4 text-primary-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                FDA Registered
              </span>
              <span>·</span>
              <span>Physician-Supervised</span>
              <span>·</span>
              <span>HIPAA Compliant</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Contact;
